import React, { useEffect, useState, useMemo } from "react";
import { Table, Grid } from "antd";
import axios from "axios";
import { folioColumns } from "../columns/folioColumns";
import { LedgerResponsiveWrapper, API_BASE, getArn, rowMatchesSearch } from "../LedgerResponsive";
const money=v=>`₹${Number(v||0).toLocaleString()}`;
export default function FolioTable({ pan, onOpenModal, onDrillFolio, searchQuery }) {
  const screens=Grid.useBreakpoint(),isMobile=!screens.md;
  const [folios, setFolios] = useState([]); const [loading, setLoading] = useState(false);
  useEffect(() => { if (!pan) return; setLoading(true);
    axios.get(`${API_BASE}/get_folios.php?pan=${pan}&arn_no=${getArn()}`)
      .then((res) => setFolios(res.data && Array.isArray(res.data.folios) ? res.data.folios : []))
      .catch(() => setFolios([])).finally(() => setLoading(false));
  }, [pan]);
  const filtered = useMemo(() => folios.filter(r => rowMatchesSearch(r, searchQuery)), [folios, searchQuery]);
  const mobileColumns=[
    {title:"Folio",dataIndex:"folio_number",key:"folio_number",width:"32%",render:t=><span style={{color:"#1677ff"}}>{t}</span>},
    {title:"AMC",dataIndex:"amc_name",key:"amc_name",width:"28%",ellipsis:true},
    {title:"Cost",dataIndex:"remaining_cost_value",key:"remaining_cost_value",width:"20%",align:"right",render:money},
    {title:"Current",dataIndex:"current_value",key:"current_value",width:"20%",align:"right",render:money},
  ];
  return <LedgerResponsiveWrapper><Table loading={loading} columns={isMobile?mobileColumns:folioColumns(onOpenModal)} dataSource={filtered}
    rowKey="folio_number" pagination={false} bordered sticky scroll={isMobile?undefined:{x:"max-content"}} tableLayout={isMobile?"fixed":"auto"} className={isMobile?"kg-mobile-nowrap-table":""}
    onRow={(record)=>({onClick:(e)=>{if(e.target.closest("button,a,[role='button']"))return;onDrillFolio?.(record);},style:{cursor:"pointer"}})} /></LedgerResponsiveWrapper>;
}
